export default "__VITE_ASSET__Cup7K4WM__"